import React from "react";
import { Box, Typography } from "@mui/material";
import { formatSecondaryLine, resolvePlayer } from "./displayHelpers";
import type { PlayerDirectory } from "./types";

interface PlayerIdentityLabelProps {
  licence: string | null | undefined;
  directory: PlayerDirectory;
  emptyLabel?: string;
  winner?: boolean;
  suffix?: string;
  /** Affiche club (± points) sous le nom. */
  showClub?: boolean;
  dense?: boolean;
}

export default function PlayerIdentityLabel({
  licence,
  directory,
  emptyLabel = "À déterminer",
  winner = false,
  suffix = "",
  showClub = true,
  dense = false,
}: PlayerIdentityLabelProps): React.ReactElement {
  const player = resolvePlayer(licence, directory, emptyLabel);
  const secondary = showClub ? formatSecondaryLine(player) : null;

  return (
    <Box
      sx={{
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        gap: dense ? 0 : 0.1,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: winner ? 700 : 500,
          color: "text.primary",
          opacity: winner ? 1 : 0.88,
          fontSize: dense ? "0.875rem" : "0.9rem",
          lineHeight: 1.3,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {player.displayName}
        {suffix}
      </Typography>
      {secondary && (
        <Typography
          component="span"
          color="text.secondary"
          sx={{
            fontSize: dense ? "0.72rem" : "0.75rem",
            lineHeight: 1.25,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {secondary}
        </Typography>
      )}
    </Box>
  );
}
